
export default {
    get
}

function get(value) {
    switch(value) {
        case 'pending': return 'Pendiente'
        case 'error': return 'Error'
        case 'success': return 'Completado'
        case 'paid': return 'Pagado'
        case 'review': return 'Revisión'
        case 'invoice': return 'Factura'
        case 'creditnote': return 'Nóta de crédito'
        case 'progress': return 'Progreso'
        case 'open': return 'Abierto'
        case 'closed': return 'Cerrado'
        case 'win': return 'Ganado'
        case 'lost': return 'Perdido'
        case 'transfer': return 'Transferencia'
        case 'cash': return 'Efectivo'
        case 'note': return 'Nota'
        case 'tracing': return 'Seguimiento'
        case 'failure': return 'Fallido'
        case 'possible': return 'Posible'
        case 'input': return 'Entrada'
        case 'output': return 'Salida'
        case 'charge': return 'Cargo'
        case 'refund': return 'Reembolso'
        case 'admin': return 'Administrador'
        case 'automatic': return 'Automático'
        case 'price': return 'Precio'
        case 'percent': return 'Porcentaje'
        case 'amount': return 'Monto'
        case 'enabled': return 'Habilitado'
        case 'disabled': return 'Deshabilitado'
        case 'public': return 'Público'
        case 'user': return 'Usuario'
        case 'prepaid': return 'Prepago'
        case 'wallet': return 'Cartera'
        default: return value
    }
}